import styled from 'styled-components';

interface ThemeProps {
    index?: number;
    $hasOverlay?: boolean;
}

//background-color: ${props => props.$colors.background};
const Content = styled.div<ThemeProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: ${props => 1000 + (props.index || 0)};
    background-color: ${props => props.$hasOverlay ? 'rgba(0, 0, 0, 0.9)' : 'transparent'};
    backdrop-filter: blur(2px); // desfoca o fundo

    button{
        background: none;
        border: none;
        outline: none;
        cursor: pointer;
    }
`;

export const Styled = {
    Content
}